module.exports = __webpack_public_path__ + "img/icon-tres-puntos.12a755ad.svg";